import { render, staticRenderFns } from "./Cuentac.vue?vue&type=template&id=1c84243f"
import script from "./Cuentac.vue?vue&type=script&lang=js"
export * from "./Cuentac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports